export const sxArchivedAthleteAlert = { maxWidth: 480 };
